import { render, staticRenderFns } from "./MetadadosComponenteDinamico.vue?vue&type=template&id=46dba79c"
import script from "./MetadadosComponenteDinamico.vue?vue&type=script&lang=js"
export * from "./MetadadosComponenteDinamico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports